import {Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../../services";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { Title } from '@angular/platform-browser';

enum LoginPage {
  'LOGIN' = 0,
  'EMAIL_VERIFY' = 1,
  'PHONE_VERIFY' = 2,
  'NEW_PASSWORD' = 3
}

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss']
})
export class AuthLoginComponent implements OnInit {

  currentYear = new Date().getFullYear();
  allowRemember = false;
  showPassword = false;

  userForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, this.authService.passwordPatternValidator]),
    remember: new FormControl(false)
  });


  constructor(private title: Title, public authService: AuthService) {}

  LoginUser() {
    var email = this.userForm.get('email')?.value || '';
    var password = this.userForm.get('password')?.value || '';
    var remember = this.userForm.get('remember')?.value || false;
    this.authService.LoginUserAndRedirect(email, password, remember);
  }

  ngOnInit() {
    this.title.setTitle("Rondeivu | Login");
    this.authService.TryReloadUser();
  }
}
